import { useUserDetailsStore } from '@/stores/useUserDetails';
import { storeToRefs } from 'pinia';

/**
 * Check if the user is able to access carrier profile based on their role and FF status
 */
async function useIsCarrierProfileEnabled() {
  const userDetailsStore = useUserDetailsStore();
  const { role } = storeToRefs(userDetailsStore);

  const acceptedRoles = new Set();

  acceptedRoles.add('admin').add('first').add('preferred').add('owner');

  const isCarrierProfileEnabled = computed(() => acceptedRoles.has(role?.value?.toLowerCase()));

  return {
    isCarrierProfileEnabled,
  };
}
export { useIsCarrierProfileEnabled };
